import React from 'react';
import RootIntercom from '../RootIntercom';
import AIChatWidget from '../AIChatWidget';
function UserSupport({ aiChatWidgetEnabled, isAdmin, coachWelcomeSeen, intercomAppId, env, tenantId, userId, userName, userEmail, userCreatedAt, intercomUserJwt, pageContext }) {
    if (aiChatWidgetEnabled) {
        return (React.createElement(React.Fragment, null,
            React.createElement(AIChatWidget, { userName: userName, presentationMode: true, pageContext: pageContext, coachWelcomeSeen: coachWelcomeSeen, isAdmin: isAdmin }),
            intercomAppId && intercomUserJwt && (React.createElement(RootIntercom, { intercomAppId: intercomAppId, env: env, tenantId: tenantId, userId: userId, userName: userName, userEmail: userEmail, userCreatedAt: userCreatedAt, intercomUserJwt: intercomUserJwt, hideDefaultLauncher: true }))));
    }
    // Only render Intercom if configuration is present
    if (!intercomAppId || !intercomUserJwt) {
        return null;
    }
    return (React.createElement(RootIntercom, { intercomAppId: intercomAppId, env: env, tenantId: tenantId, userId: userId, userName: userName, userEmail: userEmail, userCreatedAt: userCreatedAt, intercomUserJwt: intercomUserJwt }));
}
export default UserSupport;
